<template>
  <v-modal
    animation="slide-up"
    block-scroll
    theme="light-grey"
    handle-click-bg
    :full="!screen.breakPoint.tabPort"
    :position="!screen.breakPoint.tabPort ? 'bottom' : 'top'"
  >
    <template v-slot:activator="{ on }">
      <box class="mb-1" clickable @click="on()">
        <div class="dashboard-actions-item d-flex justify-stretch align-center">
          <div><span class="icon-qr_code text--xxx-large"></span></div><div class="ml-2 text--medium">{{ $t('widgets.Dashboard.DashboardActions.responseQrCode') }}</div>
        </div>
      </box>
    </template>

    <template v-slot:header>
      <div>{{ $t('widgets.Dashboard.ResponseQrCode.CreateQrCode') }}</div>
    </template>
    <div class="text--center">
      <div class="mb-2">
        <autocomplete value-field="id" item-text="fullName" v-model="selectedContact" :items="contracts" :placeholder="$t('widgets.DashboardActions.ResponseQr.contractPlaceholder')"></autocomplete>
      </div>
      <div class="dashboard-actions-item d-flex justify-center align-center m-3">
        <qr-code :loading="$apollo.queries.responseQr.loading" :content="responseQr" v-if="selectedContact"></qr-code>
        <qr-code v-else></qr-code>
      </div>
    </div>

    <template #footer>
      <v-button
        :inactive="!activeContract"
        @click="generateQrCode()"
        class="text--normalcase btn--full"
        :loading="refetching"
      >
        <div class="d-flex align-center justify-center">
          <div>{{ $t('widgets.Dashboard.ResponseQrCode.Create') }}</div>
          <div class="icon-undo-small text-color-white ml-1 text--large" v-if="!refetching"></div>
        </div>
      </v-button>
    </template>
  </v-modal>
</template>

<script>
import vModal from '@/ui/modals/vModal'
import Autocomplete from '@/ui/controls/Autocomplete'
import vButton from '@/ui/controls/vButton'
import Box from '@/ui/slots/Box'
import QrCode from '@/ui/elements/QrCode'

import currContractId from '@/mixins/currContractId'
import hasActiveContracts from '@/mixins/hasActiveContracts'
import screen from '@/mixins/screen'
import contracts from '@/mixins/contracts'
import { notifyGraphqlError } from '@/mixins/handleGraphqlError'

import { ResponseQrGQL } from '@/graphql/queries'
import { UpdateResponseQrGQL } from '@/graphql/mutations'

export default {
  components: {
    QrCode,

    Autocomplete,

    vModal,
    vButton,
    Box
  },

  mixins: [currContractId, hasActiveContracts, screen, contracts, notifyGraphqlError],

  data () {
    return {
      selectedContact: null,
      showContracts: false,
      refetching: false
    }
  },
  computed: {
    loading () {
      return (!this.responseQr && true) || (this.refetching && this.$apollo.queries.responseQr && this.$apollo.queries.responseQr.loading)
    },

    activeContract () {
      return this.contracts.find(i => parseInt(i.id) === parseInt(this.selectedContact))
    }
  },
  apollo: {
    responseQr: {
      query: ResponseQrGQL,
      variables () {
        return {
          params: {
            contractId: this.selectedContact
          }
        }
      },
      update: data => data.merchant.qr.responseQr,
      skip () { return !this.selectedContact }
    }
  },
  methods: {
    async generateQrCode () {
      try {
        await this.$apollo.mutate({
          mutation: UpdateResponseQrGQL
        })

        this.refetching = true
        await this.$apollo.queries.responseQr.refetch()
        this.refetching = false
      } catch (e) {
        this.notifyGraphqlError(e)
      }
    }
  }
}
</script>
